import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import SideBar4 from '../../components/Sidebar/SideBar4';
import { message, Switch, Form, Input } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { app } from '../../config';
import getCountryById from '../../hooks/getCountryById';
// const { MonthPicker, RangePicker } = DatePicker;
const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};
const beforeUpload = (file) => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!');
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error('Image must smaller than 2MB!');
  }
  return isJpgOrPng && isLt2M;
};
const { TextArea } = Input;
const EditCountry = () => {
  const { t } = useTranslation(['common']);
  const dateFormat = 'MM-DD-YYYY';
  const [uploadObj, setUploadObj] = useState({});
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [uploadedImg, setUploadedImg] = useState('');
  let user = JSON.parse(localStorage.getItem('user'));
  let countryId = JSON.parse(localStorage.getItem('countryId'));
  let c = getCountryById(countryId);
  let countryObj = c.response ? c.response.data : null;
  console.log(countryObj);
  let navigate = useNavigate();
  const handleChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      info.file ? setUploadedImg(info.file.response.data.Location) : ' ';
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );
  console.log(uploadedImg);
  // console.log(causeCat[0].cause_category);

  const uploadData = async (uploadObj) => {
    try {
      console.log(uploadObj);
      const res = await axios.post(`${app.URL}/country/update/${countryId}`, uploadObj);
      window.alert(res.data.message);
      if (res.data.statusCode === 200) navigate('/country/view');
    } catch (err) {
      console.log(err);
      // if (err) window.alert(err.response.data.data.message);
      // else retrun;
    }
  };
  console.log(imageUrl);
  const onFinish = (values) => {
    console.log('Success:', values);
    setUploadObj({
      name: values.name ? values.name : '',
      // stateId: values.stateId ? values.stateId : '',
      currencySymbol: values.currencySymbol ? values.currencySymbol : '',
      // image: uploadedImg? uploadedImg : causeObj.image,
      // validityDate: values.validityDate ? values.validityDate.format().split('T')[0] : causeObj.validityDate,
      isActive: values.isActive === true ? 1 : 0,
      // description: values.description ? values.description : '',
      updatedByUserId: user.userId,
    });
  };
  console.log(uploadObj);
  if (Object.keys(uploadObj).length > 0) uploadData(uploadObj);
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const renderList = []; //For testing purposes
  return (
    <div className='col-lg-9 tbl mt-4 p-4'>
      <div className='fs-3 text-center mb-4 fw-bold'>{t('Update Country')}</div>
      {c.response ? (
        <Form
          name='basic'
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          style={{
            maxWidth: 600,
          }}
          initialValues={{
            remember: true,
            ['name']: countryObj.name,
            ['currencySymbol']: countryObj.currencySymbol,
            // ['countryId']:countryObj.countryId,
            ['isActive']: countryObj.isActive === 1 ? true : false,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          <Form.Item
            colon={false}
            label='Country Name'
            name='name'
            rules={[
              {
                required: true,
                message: 'Please input your username!',
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            colon={false}
            label='Currency'
            name='currencySymbol'
            rules={[
              {
                required: true,
                message: 'Please input your username!',
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item label='Active' valuePropName='checked' colon={false} name='isActive'>
            <Switch />
          </Form.Item>
          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
            colon={false}
          >
            <button type='primary' class='btn btn-primary button' htmlType='submit'>
              Submit
            </button>
          </Form.Item>
        </Form>
      ) : (
        ' '
      )}
    </div>
  );
};

export default EditCountry;
